<template>
	<div style="height: calc(100vh - 56px); overflow-y: scroll;">
		<div class="mx-auto mt-4" style="max-width: 1320px;">
			<div>
				<CCol>
					<clientFilter v-if="isSysAdmin || isGroupAdmin" class="" />
				</CCol>
			</div>
			<div class="d-flex justify-content-center">
				<CCard>
					<CCardBody class="d-flex align-items-center justify-content-center">
						<div>
							<CInputRadio type="radio" id="viewModeOptionVendor" label="View by Vendor"
								:checked="viewMode === 'vendor'" @click="viewModeChangeHandler('vendor')" />
							<CInputRadio type="radio" id="viewModeOptionCategory" label="View by Category"
								:checked="viewMode === 'category'" @click="viewModeChangeHandler('category')" />
						</div>
						<v-select v-if="viewMode === 'vendor'" label="vendor_name" class="pl-5"
							style="min-width: 300px; max-width: 700px;" placeholder="Select vendors" :options="vendors"
							v-model="selectedVendors" :multiple="true" @input="listChangeHandler" />
						<v-select v-if="viewMode === 'category'" label="category_name" class="pl-5"
							style="min-width: 300px; max-width: 700px;" placeholder="Select categories"
							:options="categories" v-model="selectedCategories" :multiple="true"
							@input="listChangeHandler" />
					</CCardBody>
				</CCard>
			</div>

			<div class="d-flex">
				<CCol sm="12">
					<CCard class="mb-0">
						<CCardBody>
							<div class="pagination-container">
								<CButtonGroup class="align-items-center">
									<CButton color="white" size="sm" :disabled="isPrevPageDisabled"
										:class="{ selected: isPrevPageDisabled }" @click="moveToPage('FIRST')"
										class="nextButton">
										First
									</CButton>
									<CButton color="white" size="sm" :disabled="isPrevPageDisabled"
										:class="{ selected: isPrevPageDisabled }" @click="moveToPage('PREV')"
										class="nextButton">
										Previous</CButton>
									<small class="h6 m-0 mx-3">
										{{ `${offset + 1} - ${offset + limit > totalOppGroupCount ?
											totalOppGroupCount : offset + limit} of ${totalOppGroupCount}` }}
									</small><br />
									<CButton color="white" size="sm" :disabled="isNextPageDisabled"
										:class="{ selected: isNextPageDisabled }" @click="moveToPage('NEXT')"
										class="nextButton">
										Next
									</CButton>
									<CButton color="white" size="sm" :disabled="isNextPageDisabled"
										:class="{ selected: isNextPageDisabled }" @click="moveToPage('LAST')"
										class="nextButton">
										Last
									</CButton>
								</CButtonGroup>
							</div>
							<div class="grid-container-with-2-columns">
								<div>
									<Barchart style="height: 416px" :chart-data="chartData" :key="1">
									</Barchart>
								</div>
								<div>
									<CDataTable class="sticky-header-table" stickyHeader striped :items="tableData"
										:fields="viewMode === 'category' ? VENDORS_TABLE_COLUMNS : CATEGORIES_TABLE_COLUMNS"
										:column-filter="false" :items-per-page="limit"
										@row-clicked="rowClickHandler"
										clickableRows>
									</CDataTable>
								</div>
							</div>
						</CCardBody>

					</CCard>
				</CCol>
			</div>
		</div>
		<CElementCover v-if="spinner" :opacity="0.8" style="z-index: 1;" />
	</div>
</template>

<script>
import _ from "../Utility/utility";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.min.css"
import gql from "graphql-tag";
import clientFilter from "../../components/clientFilter";
import Barchart from "../../components/charts/Barchart";
import { storeData } from "../../store";
import { getSelectedClients } from "../../store";

export default {
	data() {
		return {
			CATEGORIES_TABLE_COLUMNS: [{ key: "secondary_category_name" }, { key: "po_spend" }, { key: "non_po_spend" }],
			VENDORS_TABLE_COLUMNS: [{ key: "vendor_source" }, { key: "po_spend" }, { key: "non_po_spend" }],
			BAR_CHART_DATASET_CONFIGS: [
				{
					key: "po_spend",
					label: "PO",
					barColor: '#2f5233'
				},
				{
					key: "non_po_spend",
					label: "Non PO",
					barColor: '#94c973'
				},
			],
			spinner: false,
			viewMode: "vendor",
			vendors: [],
			selectedVendors: [],
			categories: [],
			selectedCategories: [],
			chartData: {},
			tableData: [],
			isNextPageDisabled: false,
			isPrevPageDisabled: true,
			offset: 0,
			limit: 10,
			totalOppGroupCount: 0,
		};
	},
	components: {
		clientFilter,
		vSelect,
		Barchart,
	},
	computed: {
		isSysAdmin() {
			return storeData.currentUserDetails.role.name === "sys_admin";
		},
		isGroupAdmin() {
			return storeData.currentUserDetails.role.name === "group_admin";
		},
		selectedClients() {
			return getSelectedClients();
		}
	},
	watch: {
		async selectedClients() {
			this.spinner = true;
			this.selectedVendors = [];
			this.selectedCategories = [];
			await this.fetchVendors();
			await this.fetchCategories();
			await this.fetchSpendData();
			this.moveToPage("FIRST");
			this.spinner = false;
		},
		async offset() {
			this.spinner = true;
			await this.fetchSpendData();
			this.spinner = false;
		},
	},
	methods: {
		rowClickHandler (item, index, columnName, event) {
			if(this.viewMode === "vendor") {
				const selectedCategory =this.categories.find(c => c.category_id === item.id);
				this.selectedCategories = [selectedCategory];
				this.viewModeChangeHandler("category");
			}
			else {
				const selectedVendor =this.vendors.find(v => v.vendor_id === item.id);
				this.selectedVendors = [selectedVendor];
				this.viewModeChangeHandler("vendor");
			}
		},
		getBarChartData(rawData, chartConfigs) {
			return {
				datasets: chartConfigs.map(config => ({
					data: rawData[config.key],
					backgroundColor: config.barColor,
					label: config.label,
				})),
				labels: rawData.xAxisLabels,
				tooltipLabels: rawData.xAxisLabels,
			};
		},
		moveToPage(target) {
			switch (target) {
				case "FIRST":
					this.offset = 0;
					this.isPrevPageDisabled = true;
					this.isNextPageDisabled = false;
					break;
				case "NEXT":
					this.offset = this.offset + this.limit;
					this.isPrevPageDisabled = false;
					if (this.offset + this.limit >= this.totalOppGroupCount) {
						this.isNextPageDisabled = true;
					}
					break;
				case "PREV":
					this.offset = this.offset - this.limit;
					this.isNextPageDisabled = false;
					if (this.offset - this.limit < 0) {
						this.isPrevPageDisabled = true;
					}
					break;
				case "LAST":
					const residue = this.totalOppGroupCount % this.limit;
					this.offset = this.totalOppGroupCount - residue;
					this.isNextPageDisabled = true;
					this.isPrevPageDisabled = false;
					break;
				default:
					break;
			}
		},
		async listChangeHandler() {
			await this.fetchSpendData();
			this.moveToPage("FIRST");
		},
		async viewModeChangeHandler(val) {
			this.viewMode = val;
			await this.fetchSpendData();
			this.moveToPage("FIRST");
		},
		async fetchSpendData() {
			this.spinner = true;
			if (this.viewMode === "category") {
				await this.$apollo
					.mutate({
						mutation: SPENDMD_DB_SPEND_BY_VENDOR_SUPPLIES,
						variables: {
							clients: this.selectedClients,
							categories: this.selectedCategories.map(c => c.category_id),
							limit_value: this.limit,
							offset_value: this.offset
						},
					})
					.then((res) => {
						let result = res.data.spendmd_db_spend_by_vendor_supplies;
						if (result) {
							const tempChartData = {
							};

							const tempTableData = [];

							this.BAR_CHART_DATASET_CONFIGS.forEach(config => {
								tempChartData[config.key] = [];
							});
							tempChartData.xAxisLabels = [];

							result.forEach((el) => {
								this.BAR_CHART_DATASET_CONFIGS.forEach(config => {
									tempChartData[config.key].push(_.parseAmountToNumber(el[config.key]));
								})
								tempChartData.xAxisLabels.push(el.vendor_source);

								tempTableData.push({
									id: el.vendor_id,
									vendor_source: el.vendor_source,
									non_po_spend: el.non_po_spend,
									po_spend: el.po_spend,
								})
							});

							this.chartData = this.getBarChartData(tempChartData, this.BAR_CHART_DATASET_CONFIGS);
							this.tableData = tempTableData;
						}

					}).catch((err) => {
						console.log(err);
					});

				await this.$apollo
					.mutate({
						mutation: SPENDMD_DB_SPEND_BY_VENDOR_SUPPLIES_AGGREGATE,
						variables: {
							clients: this.selectedClients,
							categories: this.selectedCategories.map(c => c.category_id),
						},
					})
					.then((res) => {
						this.totalOppGroupCount = res.data.spendmd_db_spend_by_vendor_supplies_aggregate.aggregate.count;
					}).catch((err) => {
						console.log(err);
					});

			}
			else if (this.viewMode === "vendor") {
				await this.$apollo
					.mutate({
						mutation: SPENDMD_DB_SPEND_BY_CATEGORY_SUPPLIES,
						variables: {
							vendors: this.selectedVendors.map(v => v.vendor_id),
							clients: this.selectedClients,
							limit_value: this.limit,
							offset_value: this.offset
						},
					})
					.then((res) => {
						let result = res.data.spendmd_db_spend_by_category_supplies;
						if (result) {
							const tempChartData = {
							};

							const tempTableData = [];

							this.BAR_CHART_DATASET_CONFIGS.forEach(config => {
								tempChartData[config.key] = [];
							});
							tempChartData.xAxisLabels = [];

							result.forEach((el) => {
								this.BAR_CHART_DATASET_CONFIGS.forEach(config => {
									tempChartData[config.key].push(_.parseAmountToNumber(el[config.key]));
								})
								tempChartData.xAxisLabels.push(el.secondary_category_name);
								
								tempTableData.push({
									id: el.secondary_category_id,
									secondary_category_name: el.secondary_category_name,
									non_po_spend: el.non_po_spend,
									po_spend: el.po_spend,
								})
							});
							this.chartData = this.getBarChartData(tempChartData, this.BAR_CHART_DATASET_CONFIGS);
							this.tableData = tempTableData;
						}

					}).catch((err) => {
						console.log(err);
					});

				await this.$apollo
					.mutate({
						mutation: SPENDMD_DB_SPEND_BY_CATEGORY_SUPPLIES_AGGREGATE,
						variables: {
							vendors: this.selectedVendors.map(v => v.vendor_id),
							clients: this.selectedClients,
						},
					})
					.then((res) => {
						this.totalOppGroupCount = res.data.spendmd_db_spend_by_category_supplies_aggregate.aggregate.count;
					}).catch((err) => {
						console.log(err);
					});
			}

			this.spinner = false;
		},
		async fetchVendors() {
			await this.$apollo
				.mutate({
					mutation: SPENDMD_DB_VENDOR_LIST,
					variables: {
						clients: this.selectedClients,
					},
				})
				.then((res) => {
					this.vendors = res.data.spendmd_db_vendor_list;

				}).catch((err) => {
					console.log(err);
				});
		},
		async fetchCategories() {
			await this.$apollo
				.mutate({
					mutation: SPENDMD_DB_SECONDARY_CATEGORY_LIST,
					variables: {
						clients: this.selectedClients,
					},
				})
				.then((res) => {
					this.categories = res.data.spendmd_db_secondary_category_list;

				}).catch((err) => {
					console.log(err);
				});
		},
	},
	async mounted() {
		this.spinner = true;
		await this.fetchVendors();
		await this.fetchCategories();
		await this.fetchSpendData();
		this.spinner = false;
	}
};


const SPENDMD_DB_VENDOR_LIST = gql`
	query (
		$clients: json
	) {
		spendmd_db_vendor_list(
			args: {
				clients: $clients
			}
			order_by: {vendor_name: asc}
		) {
			vendor_id
			vendor_name
		}
	}
`;

const SPENDMD_DB_SECONDARY_CATEGORY_LIST = gql`
	query (
		$clients: json
	) {
		spendmd_db_secondary_category_list(
			args: {
				clients: $clients
			}
			order_by: {category_name: asc}
		) {
			category_id
			category_name
		}
	}
`;

const SPENDMD_DB_SPEND_BY_VENDOR_SUPPLIES = gql`
	query ( 
		$categories: json, 
		$clients: json, 
		$limit_value: Int, 
		$offset_value: Int 
	) { 
		spendmd_db_spend_by_vendor_supplies( 
			args: { 
				categories: $categories, 
				clients: $clients,
			} 
			limit: $limit_value, 
			offset: $offset_value   
		) { 
			vendor_id 
			vendor_source 
			non_po_spend 
			po_spend 
		}
	}
`;

const SPENDMD_DB_SPEND_BY_VENDOR_SUPPLIES_AGGREGATE = gql`
	query ( 
		$categories: json, 
		$clients: json, 
	) { 
		spendmd_db_spend_by_vendor_supplies_aggregate( 
			args: { 
				categories: $categories, 
				clients: $clients, 
			} 
		) { 
			aggregate {
				count
			}
		}
	}
`;
const SPENDMD_DB_SPEND_BY_CATEGORY_SUPPLIES = gql`
	query (
		$clients: json,
		$limit_value: Int,
		$offset_value: Int,
		$vendors: json
	) {
		spendmd_db_spend_by_category_supplies(
			args: {
				clients: $clients,
				vendors: $vendors
			}
			limit: $limit_value
			offset: $offset_value
		) {
			secondary_category_id
			secondary_category_name
			non_po_spend
			po_spend
		}
	}
`;

const SPENDMD_DB_SPEND_BY_CATEGORY_SUPPLIES_AGGREGATE = gql`
	query ( 
		$clients: json,
		$vendors: json
	) { 
		spendmd_db_spend_by_category_supplies_aggregate( 
			args: { 
				clients: $clients,
				vendors: $vendors 
			} 
		) { 
			aggregate {
				count
			}
		}
	}
`;
</script>

<style scoped>
.grid-container-with-2-columns {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 64px;
	align-items: end;
}

.sticky-header-table::v-deep>div {
	height: 420px;
	overflow-y: auto;
	position: inherit;
}

.sticky-header-table::v-deep table {
	margin-bottom: 0;
	height: 1px;
}

.sticky-header-table::v-deep .pagination {
	margin-bottom: 0;
	margin-top: 16px;
}

.sticky-header-table::v-deep table>thead {
	position: sticky;
	top: 0;
	z-index: 1;
}

.sticky-header-table::v-deep table>thead>tr>th {
	padding: 0;
	border: none;
	background-color: white;
}

.sticky-header-table::v-deep table>thead>tr>th>div {
    background-color: white;
    border-bottom: 1px solid;
    border-bottom-color: #d8dbe0;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 1.8rem 0.75rem;
}

.sticky-header-table::v-deep table>thead>tr>th>div.column-filter {
	padding: 8px 0;
	border-bottom: none;
}

.pagination-container {
	display: flex;
	justify-content: center;
	margin: 0px 0 16px;
}

.nextButton {
	padding: 8px 16px;
	margin: auto 2px;
	background-color: white !important;
	color: #1f2621 !important;
}

.nextButton[disabled=disabled] {
	cursor: not-allowed;
}

.selected {
	background-color: #9ca8a9 !important;
	color: #ffffff !important;
}
</style>
